import moment from 'moment';

export const UserAPIDefaultModel: IUserAPIModel = {
  id: '',
  avatarURL: '',
  firstName: '',
  lastName: '',
  emailAddress: '',
  city: '',
  state: '',
  welcomeScreenLastSeen: null,
  foundOutAboutGIK: null,
};

export interface IUserAPIModel {
  id: string;
  avatarURL: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  city: string;
  state: string;
  welcomeScreenLastSeen?: string;
  foundOutAboutGIK: string;
}

export default class User {
  private id: string;
  private avatarURL: string;
  private firstName: string;
  private lastName: string;
  private emailAddress: string;
  private city: string;
  private state: string;
  private welcomeScreenLastSeen: moment.Moment;
  private foundOutAboutGIK: string;

  public static toAPI(user: User): IUserAPIModel {
    return {
      id: user.getId(),
      avatarURL: user.getAvatarURL(),
      firstName: user.getFirstName(),
      lastName: user.getLastName(),
      emailAddress: user.getEmailAddress(),
      city: user.getCity(),
      state: user.getState(),
      foundOutAboutGIK: user.getFoundOutAboutGIK(),
    };
  }

  public static fromAPI({
    id,
    avatarURL,
    firstName,
    lastName,
    emailAddress,
    city,
    state,
    welcomeScreenLastSeen,
    foundOutAboutGIK,
  }: IUserAPIModel = UserAPIDefaultModel) {
    const u = new User();

    u.id = id;
    u.avatarURL = avatarURL;
    u.firstName = firstName;
    u.lastName = lastName;
    u.emailAddress = emailAddress;
    u.city = city;
    u.state = state;

    if (welcomeScreenLastSeen === null) {
      u.welcomeScreenLastSeen = null;
    } else {
      u.welcomeScreenLastSeen = moment.utc(welcomeScreenLastSeen);
    }
    u.foundOutAboutGIK = foundOutAboutGIK;

    return u;
  }

  public getId(): string {
    return this.id;
  }

  public getAvatarURL(): string {
    return this.avatarURL;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public getLastName(): string {
    return this.lastName;
  }

  public getEmailAddress(): string {
    return this.emailAddress;
  }

  public getCity(): string {
    return this.city;
  }

  public getState(): string {
    return this.state;
  }

  public getWelcomeScreenLastSeen(): moment.Moment {
    return this.welcomeScreenLastSeen;
  }

  public getFoundOutAboutGIK(): string {
    return this.foundOutAboutGIK;
  }
}
